import React from 'react'
import {
  TransportStopsTableProps,
  StopRowProps,
  StopIconProps,
  StopNameProps,
  StopDistanceProps,
} from './TransportStopsTable.types'
import {
  StopsTable as StyledStopsTable,
  StopRow as StyledStopRow,
  StopIcon as StyledStopIcon,
  StopName as StyledStopName,
  StopDistance as StyledStopDistance,
} from './TransportStopsTable.styles'

export const TransportStopsTable: React.FC<TransportStopsTableProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledStopsTable className={className} style={style}>
      {children}
    </StyledStopsTable>
  )
}

export const StopRow: React.FC<StopRowProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledStopRow className={className} style={style}>
      {children}
    </StyledStopRow>
  )
}

export const StopIcon: React.FC<StopIconProps> = ({
  type,
  children,
  className,
  style,
}) => {
  return (
    <StyledStopIcon $type={type} className={className} style={style}>
      {children}
    </StyledStopIcon>
  )
}

export const StopName: React.FC<StopNameProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledStopName className={className} style={style}>
      {children}
    </StyledStopName>
  )
}

export const StopDistance: React.FC<StopDistanceProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledStopDistance className={className} style={style}>
      {children}
    </StyledStopDistance>
  )
}

TransportStopsTable.displayName = 'TransportStopsTable'
StopRow.displayName = 'StopRow'
StopIcon.displayName = 'StopIcon'
StopName.displayName = 'StopName'
StopDistance.displayName = 'StopDistance'
